import actionTypes from "./actionTypes.js";
import namespace from './namespace';
export default {
  namespace,
  state: {
    serviceConfig: {
      integralName: "积分",
      //积分配置名称
      inviteConfig: 1,
      //积分配置存在
      openCer: 1,
      //我的证书开关
      openCoupons: 0,
      //开启优惠卷服务
      openCreate: 1,
      //小组创建
      openExam: 0,
      //我的考试开关
      openFadService: 1,
      //一对一答疑开关
      openGro: 0,
      //我的小组开关
      openHomeWork: 0,
      //我的作业开关
      openIntegral: 0,
      //积分开关
      openInvite: 0,
      //开通机构邀请码
      openIsAgent: 0,
      // 代报考开关
      openIsQsAnswer: 1,
      //我的答疑-存在配置
      openNote: 1,
      //录播服务-笔记开关
      openPackage: 0,
      //课程包开关
      openQsAnswer: 1,
      //我的问答开关
      openQuestion: 1,
      //我的答疑开关
      openReCha: 0,
      //余额开关
      openRes: 0,
      //我的资源(共享资源)开关
      openStudyCard: 1,
      //学习卡开关
      openTiku: 0,
      //题库开关
      openUpgradeTiku: 1,
      //是否开启新题库
      openVip: 0,
      //我的会员开关
      openWD: 0,
      //开启课程问答/问答社区服务;课程问答/问答社区服务
      packageName: "课程包",
      // 课程包配置名称
      vipConfig: 1,
      //会员配置存在
      stageName: "阶段",
      // 课程包中阶段名称
      openDetail: 1,
      // 订单详情开关
      openInvoicing: 1 //开具发票开关

    },
    changePasswordConfig: 0 //修改密码配置

  },
  reducers: {
    [actionTypes.GET_SERVICE_CONFIG](state, action) {
      // console.log(action, "action=====")
      return { ...state,
        serviceConfig: { ...action.data
        }
      };
    },

    [actionTypes.GET_ACCOUNT_INFO](state, action) {
      return { ...state,
        accountInfo: action.data
      };
    },

    [actionTypes.GET_CHANGE_PASSWORD_CONFIG](state, action) {
      return { ...state,
        changePasswordConfig: action.data
      };
    }

  }
};